import { z } from 'zod';

export const CUSTOM_FIELD_TYPE = {
  CHECKBOX: 'FIELD_TYPE_CHECKBOX',
  CURRENCY: 'FIELD_TYPE_CURRENCY',
  DATE: 'FIELD_TYPE_DATE',
  ITEM: 'FIELD_TYPE_ITEM',
  LINK: 'FIELD_TYPE_LINK',
  MULTI_ITEM: 'FIELD_TYPE_MULTI_ITEM',
  MULTI_LINK: 'FIELD_TYPE_MULTI_LINK',
  MULTI_PICKLIST: 'FIELD_TYPE_MULTI_PICKLIST',
  MULTI_TEXT: 'FIELD_TYPE_MULTI_TEXT',
  MULTI_USER: 'FIELD_TYPE_MULTI_USER',
  MULTILINE_TEXT: 'FIELD_TYPE_MULTILINE_TEXT',
  NOTE: 'FIELD_TYPE_NOTE',
  NUMERIC: 'FIELD_TYPE_NUMERIC',
  PICKLIST: 'FIELD_TYPE_PICKLIST',
  TEXT: 'FIELD_TYPE_TEXT',
  USER: 'FIELD_TYPE_USER',
} as const;

export const customFieldTypeSchema = z.enum(CUSTOM_FIELD_TYPE);

export const picklistOptionSchema = z.object({
  id: z.number().int().positive(),
  fieldId: z.number().int().positive(),
  name: z.string(),
  color: z.string(),
  priority: z.string(),
  archivedAt: z.number().int().optional(),
});

export const customFieldSchema = z.object({
  id: z.number().int().positive(),
  name: z.string(),
  currencyUnit: z.string().optional(),
  type: customFieldTypeSchema,
  priority: z.string(),
  picklistOptions: z.array(picklistOptionSchema),
  archivedAt: z.number().int().optional(),
});

export type CustomFieldType = z.infer<typeof customFieldTypeSchema>;
export type PicklistOptionDTO = z.infer<typeof picklistOptionSchema>;
export type CustomFieldDTO = z.infer<typeof customFieldSchema>;
